import { markupOutboxScopeKey, type MarkupOutboxScope } from "./markupOutbox";

const active = new Map<string, number>();
const listeners = new Set<() => void>();

function changed(): void { listeners.forEach((listener) => listener()); }

/** The mounted viewer owns applying a delivered save's draft/version to its UI. */
export function registerActiveMarkupOutboxScope(scope: MarkupOutboxScope): () => void {
    const key = markupOutboxScopeKey(scope);
    active.set(key, (active.get(key) ?? 0) + 1);
    changed();
    let released = false;
    return () => {
        if (released) return;
        released = true;
        const count = active.get(key) ?? 0;
        if (count <= 1) active.delete(key); else active.set(key, count - 1);
        changed();
    };
}

export function isMarkupOutboxScopeActive(scope: MarkupOutboxScope): boolean {
    return (active.get(markupOutboxScopeKey(scope)) ?? 0) > 0;
}

export function subscribeMarkupOutboxActiveScopes(listener: () => void): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
}
